export default "__VITE_ASSET__4a0322f2__"